export default {
      id: "obs_pos-usage",
      viewBox: "0 0 43 42",
      url: __webpack_public_path__ + "img/icons.cd84ca0f.svg#obs_pos",
      toString: function () {
        return this.url;
      }
    }